import type { SearchLogisticsObjectsRequest } from '@/api/bol';

/**
 * Default search query for logistics object list pages.
 * Sorts by last updated date descending so the most recently updated items appear first.
 */
export const DEFAULT_LOGISTICS_OBJECT_SEARCH_QUERY: SearchLogisticsObjectsRequest = {
  sort: [{ 'lo.updatedAt': 'desc' }],
};

export const getEffectiveLogisticsObjectSearchQuery = (
  searchQuery?: SearchLogisticsObjectsRequest,
): SearchLogisticsObjectsRequest => {
  if (searchQuery !== undefined) {
    return searchQuery;
  }

  return DEFAULT_LOGISTICS_OBJECT_SEARCH_QUERY;
};
